export var LogType;
(function (LogType) {
    LogType["ERROR"] = "ERROR";
    LogType["INFO"] = "INFO";
    LogType["TELEMETRY"] = "TELEMETRY";
})(LogType || (LogType = {}));
